"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonOrLink = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const index_1 = require("./index");
function getButtonOrLink(content, 
// PressEvent set by React-Aria's `useButton`.
onClick, attrs, openInNew = false, downloadLink = false) {
    return typeof onClick === "string" ? ((0, index_1.isAbsoluteUrl)(onClick) || openInNew || downloadLink ? ((0, jsx_runtime_1.jsx)("a", { ...attrs, href: onClick, ...(downloadLink ? { download: "" } : { target: "_blank", rel: "noreferrer noopener" }), children: content })) : ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { ...attrs, to: onClick, children: content }))) : (
    // Cast `onClick` as VoidFunction this is the type if will be if not overwritten by `attrs` (which happens via Button.tsx)
    // Type `(e: PressEvent) => {}` is only used but Button.tsx, which passes the `onClick` prop as part of the `attrs`.
    (0, jsx_runtime_1.jsx)("button", { onClick: onClick, ...attrs, children: content }));
}
exports.getButtonOrLink = getButtonOrLink;
